import listViewStore from '../store/Store';
export default function isConversationExpanded(rowKey) {
    return (listViewStore.expandedConversationViewState.expandedRowKey == rowKey &&
        !listViewStore.expandedConversationViewState.shouldBeExpanded);
}
//# sourceMappingURL=isConversationExpanded.js.map